export enum PriceType {
  PRICE = 'price',
  YIELD = 'yield',
}
